module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0006-5a4d534dce8096de3b470a70562f5e36.jpg";